import React, { Component } from 'react';
import './PeriodicTable.css';
import Elements from "../Elements.json";
import Element from './Element'
import ElementDetail from "./ElementDetail";

class PeriodicTable extends Component {
  constructor(props) {
    super(props);
    this.setDetailElement = this.setDetailElement.bind(this);
    this.state = {detailElement: null};
  }

  setDetailElement(element){
    console.log(element);
    this.setState({detailElement: element})
  }

  render() {
    const elements = Elements.Elements.map(function (d) {
      return (
        d.Period &&
        <div key={d.Z}
             className="element-wrapper"
             style={{"left": (d.Group-1)*100 / 18 + "%", "top": (d.Period-1)*100 / 7 + "%"}}
             onMouseOver={this.setDetailElement.bind(this, d)}>
          <Element element={d}/>
        </div>
      );
    }, this);

    return (
      <div className="periodic-table">
        <ElementDetail element={this.state.detailElement}/>
        <div className="elements">
          {elements}
        </div>
      </div>
    );
  }
}

export default PeriodicTable;



// WEBPACK FOOTER //
// ./src/components/PeriodicTable.js